// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__16hNB","header":"ReportDetails_header__5Wp4-","title":"ReportDetails_title__1u47s","left":"ReportDetails_left__1Etf6"};